import { useCallback } from 'react';
import { Icon } from '../../../../../elements';
import { useMediaQueries } from "../../../../../utils/mediaQueries";
import {
  SelectorListItem,
  SelectorListItemAvatarWrapper,
  SelectorListItemName,
  SelectorListItemTeam
}  from './AgentTeamSelector.styled';

const AgentTeamListItem = ({ avatar, name, team, onClick, id }) => {
  const { isMobile, isTablet } = useMediaQueries();
  const onHandleClick = useCallback(() => {
    onClick && onClick(id);
  }, [id, onClick]);

  return (
    <SelectorListItem onClick={onHandleClick} isTablet={isTablet}>
      <SelectorListItemAvatarWrapper>
        { avatar === undefined && <Icon name="carbonUserAvatarFilled" width="24px" height="24px" />}
        { avatar && avatar}
      </SelectorListItemAvatarWrapper>
      <SelectorListItemName isMobile={isMobile} isTablet={isTablet} title={name}>{name}</SelectorListItemName>
      <SelectorListItemTeam>{team}</SelectorListItemTeam>
    </SelectorListItem>
  );
};

export default AgentTeamListItem;
